import React, { ReactNode } from 'react'
import { CenteredSpinner } from './Spinner'
/**
 * Loading spinner used to cover content while isLoading from data loading hook is true
 */
export const LoadingSpinner = ({
  children,
  isLoading,
  ...props
}: {
  children: ReactNode
  isLoading: boolean
} & React.HTMLProps<React.ReactNode>) => {
  return isLoading ? <CenteredSpinner {...props} /> : <>{children}</>
}
